// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__Ywt5V","total":"AdvancePaymentDetails_total__yauB3","edit":"AdvancePaymentDetails_edit__c1iaG"};